import styled, { css } from 'styled-components';
import { breakpoints } from 'theme';

export const StyledEditorWrapper = styled.div<{ $fill?: boolean }>`
  position: relative;

  ${({ $fill }) =>
    $fill &&
    css`
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
    `}
`;

export const StyledEditable = styled.div<{ $fill?: boolean }>`
  min-height: 220px;
  ${({ $fill }) =>
    $fill &&
    css`
      flex: 1 1 auto;
    `}
  outline: none;
  text-align: left;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.65;
  color: ${({ theme }) => theme.color.pickledBluewood};
  word-break: break-word;
  overflow-wrap: anywhere;
  cursor: text;

  & ::selection {
    background: ${({ theme }) => `${theme.color.koromiko}55`};
  }

  & a {
    color: ${({ theme }) => theme.color.brightTurquoise};
    text-decoration: underline;
  }

  @media ${breakpoints.downSmPlus} {
    min-height: 180px;
    font-size: 14px;
  }
`;

export const StyledPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  font-size: 15px;
  line-height: 1.65;
  color: ${({ theme }) => theme.color.casper};
  pointer-events: none;
  user-select: none;

  @media ${breakpoints.downSmPlus} {
    font-size: 14px;
  }
`;

export const StyledToolbar = styled.div.attrs<{ top: number; left: number }>(
  ({ top, left }) => ({ style: { top, left } }),
)<{ visible: boolean; top: number; left: number }>`
  position: fixed;
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 2px;
  height: 40px;
  padding: 0 4px;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.shark};
  box-shadow: 0 10px 30px -8px ${({ theme }) => theme.color.darkGrey};
  white-space: nowrap;
  transform-origin: bottom center;
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s;

  ${({ visible }) =>
    visible
      ? css`
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0) scale(1);
        `
      : css`
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transform: translateX(-50%) translateY(4px) scale(0.97);
        `}
`;

export const StyledToolbarButton = styled.button<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.white};
  background: ${({ active, theme }) =>
    active ? `${theme.color.white}2E` : 'transparent'};
  transition: background 0.12s ease;

  &:hover {
    background: ${({ theme }) => `${theme.color.white}1F`};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.brightTurquoise};
    outline-offset: -2px;
  }
`;

export const StyledToolbarDivider = styled.span`
  width: 1px;
  height: 20px;
  margin: 0 4px;
  background: ${({ theme }) => `${theme.color.white}33`};
`;

export const StyledLinkForm = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 6px;
`;

export const StyledLinkInput = styled.input<{ invalid?: boolean }>`
  width: 240px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid
    ${({ invalid, theme }) =>
      invalid ? theme.color.bittersweet : 'transparent'};
  border-radius: 6px;
  outline: none;
  font-size: 13px;
  color: ${({ theme }) => theme.color.white};
  background: ${({ theme }) => `${theme.color.white}1A`};

  &::placeholder {
    color: ${({ theme }) => theme.color.casper};
  }

  @media ${breakpoints.downSmPlus} {
    width: 180px;
  }
`;
